/* eslint-disable no-unused-expressions */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { FiCheck, FiClock } from 'react-icons/fi';
import {
  formatEntry,
  formatPrice,
  formatVisaType,
} from '../../utils/onlineVisaUtils';
import './VisaCard.scss';

function VisaCard({
  visa,
  selected,
  onSelect,
  shareSelectionMode,
  shareSelected,
  onShareToggle,
}) {
  const adultFare = visa.visaFare.paxWisePriceList?.find(
    (pax) => pax.paxType === 'ADT',
  );
  const adultPerPaxPrice = adultFare.PaxFareQuoteTotal / adultFare.paxCount;
  const price =
    formatPrice(adultPerPaxPrice, visa?.visaFare?.currency) ||
    visa?.priceDisplay ||
    '';

  const validityDisplay =
    visa?.validityDisplay ||
    `${visa?.validity || ''} ${visa?.validityType || ''}`.trim();
  const durationDisplay =
    visa?.durationDisplay ||
    `${visa?.duration || ''} ${visa?.durationType || ''}`.trim();
  const headline = [
    visa?.destination?.destinationName,
    formatEntry(visa?.entry),
    durationDisplay,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type="button"
      className={`visa-card ${selected ? 'visa-card--selected' : ''} ${
        shareSelectionMode ? 'visa-card--share-mode' : ''
      } ${shareSelected ? 'visa-card--share-selected' : ''}`}
      onClick={() => {
        if (shareSelectionMode) {
          onShareToggle && onShareToggle(visa);
          return;
        }
        onSelect && onSelect(visa);
      }}
    >
      {shareSelectionMode && (
        <span className="visa-card__share-circle" aria-hidden>
          {shareSelected && <FiCheck />}
        </span>
      )}

      {/* Gradient header row with title + per-traveller price */}
      <header className="visa-card__header">
        <div className="visa-card__header-bar">
          <h3 className="visa-card__headline">{visa?.visaName || headline}</h3>
        </div>
        <div className="visa-card__price-col">
          <span className="visa-card__price">{price}</span>
          <span className="visa-card__price-hint">Per Traveller</span>
        </div>
      </header>

      {/* Meta chip row: purpose • visa-type • processing */}
      <div className="visa-card__chips">
        {visa?.purpose && (
          <span className="visa-card__chip visa-card__chip--soft">
            {visa.purpose}
          </span>
        )}
        {visa?.visaType && (
          <span className="visa-card__chip visa-card__chip--outlined">
            {formatVisaType(visa.visaType)}
          </span>
        )}
        {visa?.processingTime && (
          <span className="visa-card__chip visa-card__chip--ghost">
            <FiClock />
            {visa.processingTime}
          </span>
        )}
      </div>

      {/* Three-column info strip */}
      <div className="visa-card__info">
        <div className="visa-card__info-col">
          <span className="visa-card__info-label">Entry Type</span>
          <span className="visa-card__info-value">
            {formatEntry(visa?.entry) || '—'}
          </span>
        </div>
        <div className="visa-card__info-col">
          <span className="visa-card__info-label">Validity Duration</span>
          <span className="visa-card__info-value">
            {validityDisplay || '—'}
          </span>
        </div>
        <div className="visa-card__info-col">
          <span className="visa-card__info-label">Stay Duration</span>
          <span className="visa-card__info-value">
            {durationDisplay || '—'}
          </span>
        </div>
      </div>

      {selected && (
        <span className="visa-card__selected-indicator" aria-hidden />
      )}
    </button>
  );
}

VisaCard.propTypes = {
  visa: PropTypes.object.isRequired,
  selected: PropTypes.bool,
  onSelect: PropTypes.func,
  shareSelectionMode: PropTypes.bool,
  shareSelected: PropTypes.bool,
  onShareToggle: PropTypes.func,
};

VisaCard.defaultProps = {
  selected: false,
  onSelect: null,
  shareSelectionMode: false,
  shareSelected: false,
  onShareToggle: null,
};

export default VisaCard;
